"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
require("./NavigationArrows.css");
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));
var NavigationArrows = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavigationArrows, _Component);
  var _super = (0, _createSuper2.default)(NavigationArrows);
  function NavigationArrows(props) {
    var _this;
    (0, _classCallCheck2.default)(this, NavigationArrows);
    _this = _super.call(this, props);
    _this.state = {
      page: 0,
      pageCompleted: undefined,
      // Undefined: we don't know if it's true or false yet.
      completed: false
    };
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(NavigationArrows, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (this.state.page === this.props.children.length - 1 && this.state.pageCompleted && !this.state.completed) {
        this.setState({
          completed: true
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var e = event || window.event;
      if (e.keyCode === 37 && this.state.page > 0) {
        // left arrow
        this.setState({
          page: this.state.page - 1
        });
      } else if (e.keyCode === 39 && this.state.pageCompleted && this.state.page < this.props.children.length - 1) {
        // right arrow
        this.setState({
          page: this.state.page + 1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "navigation"
      }, this.state.page > 0 && /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "outline-dark",
        className: "arrow-prev",
        onClick: function onClick() {
          _this2.setState({
            page: _this2.state.page - 1
          });
        }
      }, " \u2190"), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-wrapper"
      }, this.props.children.map ? this.props.children.map(function (child, index) {
        if (index === _this2.state.page) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            key: "page" + (_this2.props.sameKeys ? "" : index),
            index: index,
            onCompleted: function onCompleted(value) {
              _this2.setState({
                pageCompleted: value
              });
              if (_this2.props.onPageCompleted) {
                _this2.props.onPageCompleted(value);
              }
            }
          });
        }
        return null;
      }) : this.props.children), this.state.pageCompleted && this.state.completed && /*#__PURE__*/_react.default.createElement(_Alert.default, {
        variant: "info",
        style: {
          margin: "0px 50px 0px 50px",
          textAlign: "center"
        }
      }, "Interactive complete"), this.state.pageCompleted && this.state.page < this.props.children.length - 1 && /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "outline-dark",
        className: "arrow-next",
        onClick: function onClick() {
          _this2.setState({
            page: _this2.state.page + 1
          });
        }
      }, " \u2192"));
    }
  }]);
  return NavigationArrows;
}(_react.Component);